var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 18.7459C9.90639 19.0133 9.45965 19.0001 9.19224 18.7164C8.92483 18.4327 8.93802 17.986 9.2217 17.7186C11.4851 15.585 14.247 14.5132 17.4706 14.5132C20.6942 14.5132 23.4561 15.585 25.7195 17.7186C26.0032 17.986 26.0164 18.4327 25.7489 18.7164C25.4815 19.0001 25.0348 19.0133 24.7511 18.7459C22.7526 16.8619 20.338 15.9249 17.4706 15.9249C14.6032 15.9249 12.1886 16.8619 10.1901 18.7459Z",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8823 6.39009C10.8823 9.91821 13.7256 12.7802 17.2353 12.7802C20.7449 12.7802 23.5882 9.91821 23.5882 6.39009C23.5882 2.86197 20.7449 0 17.2353 0C13.7256 0 10.8823 2.86197 10.8823 6.39009ZM22.1764 6.39009C22.1764 9.14058 19.9632 11.3684 17.2353 11.3684C14.5074 11.3684 12.2941 9.14058 12.2941 6.39009C12.2941 3.63961 14.5074 1.41176 17.2353 1.41176C19.9632 1.41176 22.1764 3.63961 22.1764 6.39009Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1V8",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5H8",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPersonIcon);
export default __webpack_public_path__ + "static/media/add-person-icon.93a9852017f3dd327e3576f463e5aa51.svg";
export { ForwardRef as ReactComponent };